import { Icon } from 'components/common/Icon';
import { Img } from 'components/common/Img';
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { ColDiv, RowDiv, Span, Text } from 'styles';
import { hexToRGB } from 'utils';

export function MainProduct({ list, navigate }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiper = swiperRef.current.swiper;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [list]);

  return (
    <Container>
      <Swiper
        ref={swiperRef}
        modules={[Navigation, Autoplay]}
        navigation={{
          prevEl: '.product-prev',
          nextEl: '.product-next',
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        onSlideChange={(swiper) => {
          setCurrentIndex(swiper.realIndex);
        }}
        onSwiper={(swiper) => {
          if (swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
          }
        }}
        loop
        loopedSlides={list.length}
      >
        {list.map((product, index) => (
          <SwiperSlide key={`product_${index}`}>
            <RowDiv $gap={32} $tFlexDirection="column" $tPadding="0 24px" $maxWidth={1600} $margin="auto">
              <ImgBox>
                <Img src={product.img} alt={`${product.title} - ${product.desc.replace(/\n/g, ' ')} 주식회사 팜인`} $width={712} $height={536} $tWidth="100%" $tHeight={396} $mHeight={216} />
              </ImgBox>
              <ColDiv $justifyContent="center" $gap={24} $mGap={8} $maxWidth={544} $width="100%" $tPadding="0 32px">
                <Text $color="primary200" $type="b3" $mType="h4">
                  {product.title}
                  <Span $type="b5" $mType="b6" $color={hexToRGB('#171717', 0.4)}>
                    &nbsp;Product{product.id}
                  </Span>
                </Text>
                <Text $color="darker" $mType="b7" $whiteSpace="pre">
                  {product.desc}
                </Text>
                <RowDiv $alignItems="center" $gap={8} $cursor="pointer" onClick={() => {
                    sessionStorage.removeItem('currentIndex');
                    navigate('/product');
                  }}
                  $hover
                >
                  <Icon name="more" $width={20} $height={20} $padding="2px" />
                  <Text $color="secondary800" $type="b7" $fontWeight={500}>
                    View More
                  </Text>
                </RowDiv>
              </ColDiv>
            </RowDiv>
          </SwiperSlide>
        ))}
      </Swiper>
      <NavigationBox>
        <Icon
          className="product-prev"
          name="swiperArrow"
          $transform="rotate(180deg)"
          $width={40}
          $height={40}
          $pointer
        />
        <Pagination>
          <Text $type="b7" $color="secondary">
            {currentIndex + 1} / {list.length}
          </Text>
        </Pagination>
        <Icon
          className="product-next"
          name="swiperArrow"
          $width={40}
          $height={40}
          $pointer
        />
      </NavigationBox>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;

  .swiper {
    padding-bottom: 60px;
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0;
  }
`;

const ImgBox = styled(ColDiv)`
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
  padding: 32px 0;
  max-width: 920px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0 4px 4px 0;

  @media ${({ theme }) => theme.device.tablet} {
    border-radius: 4px;
    max-width: 100%;
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 24px 0;
  }
`;

const NavigationBox = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 10;

  @media ${({ theme }) => theme.device.mobile} {
    gap: 12px;
  }
`;

const Pagination = styled.div`
  min-width: 60px;
  text-align: center;
`;
